import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `

    <p class="mb-3">
      Neforgesebla estis printempo de la jaro 2020. 
      Jam delonge mi ne perceptis la vivon tiel forte kaj freŝe; jam delonge la sensoj ne estis tiaj akraj. 
      Okazis granda ŝanĝo en la mondo, abrupte ŝanĝiĝis ĉio, forŝirante la multjaran ŝelon de rutino, 
      de kutima ĉiutageco, kiu kovris mian menson.
    </p>

    <p class="mb-3">
      … Komenciĝis ĉio tute ordinare: mi venis al kuracisto por enviciĝi fin-fine por la operacio de katarakto, 
      ĉar la vidpovo rimarkinde ŝrumpis dum lastaj monatoj. 
      Kaj interalie mi demandis, ĉu ne malhelpos la procezon la aŭdata pli kaj pli ofte informo pri iu minacanta al la mondo pandemio. 
      La okulisto ekmiris: 
      "Ĉu al ni? Kian rilaton ĝi havus…? 
      Tute aparta tereno… 
      Ne maltrankvilu, faru analizojn kaj venu al ni post semajno". 
      Tio okazis ĵaŭde; kaj ekde lundo sekvasemajne oni anoncis severan kvarantenon.
    </p>

    <p class="mb-3">
      Mi estis ŝokita. 
      Kaj unua demando estis: 
      "Kiel povis okazi, ke kuracistoj mem ne sciis pri la venontaj ŝanĝoj? 
      Ĉu ne ili proponas kontraùmalsanajn rimedojn?". 
      Nian urbon, landon jam dum kelkaj jaroj inundas epidemioj de ftizo, de morbilo… homoj malsaniĝas, 
      mortas – sed neniu anoncas kvarantenon kaj oni eĉ ne agnoskas, ke estas veraj epidemioj: 
      oni simple parolas pri iuj sporadaj "eksplodoj" de malsanoj kaj okazigas neniujn specialajn aranĝojn… 
      Pri AIDS, ekz., vera tutmonda pandemio, eĉ tute male: oni postulas malkvarantenon, 
      kondamnas kaj malpermesas izoligon de la malsanuloj… 
      Sed jen – abrupta fermo de vendejoj, malpermeso foriri el hejmo… 
      Atmosfero de teroro. 
      Ĉiuj sidas hejme kaj timas. 
      Potencega informa premo: en ĉiuj amas-medioj oni densigas la streĉitecon kaj temas nur pri k-v-d kaj ĝiaj viktimoj. 
      La vivo fakte stagnis (aŭ estis stagnigita?). 
      Oni malpermesis ne nur eliri, sed eĉ, ial tre insiste, sportumi surstrate, en freŝa aero. 
      Malpermesis promeni en parkoj, apud la maro…
    </p>

    <p class="mb-3">
      Niaj urbaj ret-medioj tiam ofte montradis filmeton pri iu aktora familio: ili, kiel aktoroj, 
      devas perfekte posedi sian korpon, ĉiutage provludi por havi eblecon esprimi sentojn kaj sencon de siaj roloj ne nur per vortoj, 
      sed nepre ankaŭ per la t.n. "lingvo de korpo". 
      Kaj jen: teatrojn oni fermis, spektakloj kaj ankaŭ provludoj tie ne okazis,
       - kaj tiu familio decidis sin ekzerci kaj gimnastiki hejme, por ne perdi la korpan pretecon kaj esprimivon. 
       Tiu hejma ekzercado estis filmita, kaj la filmeton oni proponis al ni kiel ekzemplon kaj instigilon.
    </p>

    <p class="mb-3">
      Do, en malgranda tipa loĝejo de multetaĝa domo, kie alto de plafono estas 2.7 m., 
      kaj la areo de ĉambroj ĉ. 20 м. kv., sin trejnas viro kaj virino, kaj 5-jara infano kuras tien-reen, 
      jen aperas, jen eliras el la ĉambro. 
      La virino faras gimnastikon por fleksebleco de la korpo; sed la viro, nature, 
      pli okupiĝas pri fortigaj ekzercoj: jen kun halteroj, jen pri kaŭroj. 
      Kompreneble, li ŝvitas, kaj la kamerao ne ĝenas montri lian humidan korpon: li penegas ja, kaj vi, 
      estimataj spektantoj, faru same! 
      Vidu, li ne lasis sin venki, li daŭrigas sian laboron: jen la ekzemplo por vi!
    </p>

    <p class="mb-3">
      Kaj tiu filmeto estis la lasta guto, kiu troplenigis la kalikon de mia obeemo kaj kredemo. 
      Mi imagis, KIA aero estas en tiu malgranda, malalta ĉambro kun fermitaj fenestroj; kiu odoro de ŝvito, 
      kiu koncentriteco de CO2, kiu manko de oksigeno, intense konsumata dum fizikaj ekzercoj! 
      Strange, dum oni multfoje, preskaŭ ĉiuhore el ĉiuj ekranoj rememorigas pri neceso lavi manojn, 
      - NENIAM mi aŭdis pri neceso aerumi ĉambrojn! 
      Sed la infekto ja estas transprenata ĝuste per aero; kaj en fermitaj loĝejoj ajna infekto, ne nur la novaperinta, certe trovos por si fekundan medion! 
      La akumuliĝo de CO2 kaj manko de O2 plifebligos eĉ sanan organismon, agante ĝuste tra la pulmoj; 
      tiel aperas ideala medio por ekmalsano. Mem restado senelire en fermitaj loĝejoj, sen moviĝo en freŝa aero, 
      malfortigas kaj malaktivigas imunajn fortojn de l’ organismo; des pli en printempo, 
      kiam la tutan vintron ni kutime estas limigitaj en nia eblo moviĝi, spiri freŝan aeron ktp. 
      La printempo estas la periodo, kiam la naturo renaskiĝas post vintra dormo, reakiras siajn fortojn, 
      - kaj same strebas fari homo. 
      Ankaŭ en li reviviĝas la naturaj impetoj; kaj tiam li apatre bezonas kunvivi kun la naturo, 
      kundividi ĝiajn fortojn. 
    </p>

    <p class="mb-3">
      Kaj tiam mi klare komprenis, ke okazas rekta atenco kontraŭ mia vivo kaj sano: 
      oni devigas min ne reakiri miajn fortojn post vintra malfortiĝo, ne resanigi, 
      sed malfortigi mian imunan sistemon, preventi mian kontraŭstaron al ajna malsano. 
    </p>

    <p class="mb-3">
      Sed krom tiu tute fizika, ekzistis ankaŭ la psika premo: ja izoliĝo mem tre maligne influas homojn. 
      Ni ne estas krimuloj – sed tute sen kulpo kaj sen verdikto ni ĉiuj estis ekzilitaj, sub hejma aresto. 
      Mi ne povas eĉ imagi, kiom da homoj plene aŭ iomete freneziĝis, enfermitaj en siaj hejmoj; 
      kiom da familioj disfalis, devigitaj senĉese vidi unu la alian en limigita spaco, 
      sen eblo resti sola kun si mem, tiel bezonata kondiĉo por psika ekvilibro.
    </p>

    <p class="mb-3">
      Kaj mi impetis savi min.
    </p>

    <p class="mb-3">
      Komence mi promenis nur enurbe, tra ĝiaj parkoj kaj bulvardoj. 
      Stranga vidaĵo estis, kvazaŭ en hororfilmoj: en printempo, kiam "ajna vivo ĝuas la sunon", 
      en gaja ĉemara urbo – tute malplenaj stratoj. 
      Malplenaj benkoj en parkoj. Nur la vento furiozas, forbalaante ĉiun malpuraĵon, ĉiun "infekton". 
      Sur la stratoj – nur la Suno, la vento kaj mi.
    </p>

    <p class="mb-3">
      Mi memoras unu arbuston de forsitio en la urba parko: ĝi estis lumigita de suno, kaj, flava en flavo, 
      brilis kiel flamanta torĉo. 
      Ĝi estis simbolo de reveninta vivo, de varma kaj plenforta vivoĝojo.
    </p>

    <p class="mb-3">
      Mi promenis dum diversaj taghoroj, kaj ĉiun el ili ĝuis aparte. 
      Mi bone komprenis tiam Claude Monet kun liaj serioj de Temploj aŭ Nimfeoj, pentritaj en diversaj prilumoj. 
      Mi observis, kiel la situo de la Suno kaj de apartaj nuboj surĉiele aliigas konatajn pejzaĝojn, 
      kaj ili ĉiam ŝajnas nove allogaj. 
      Ĝuste tiam mi eksentis tion, kion mi priskribis en la unuaj alineoj: subitan malfermiĝon al impresoj, 
      kiuj denove fariĝis ardaj kaj freŝaj. 
      Eble, tion subtenis ankaŭ la guto da adrenalino: ja estis malpermesite promeni, 
      kaj min instigis ankaŭ la gaja kaj defia spitemo.
    </p>

    <p class="mb-3">
      Post ioma tempo mi ekentreprenis eĉ pli longajn promenojn. 
      Nemalproksime de mia domo estas longa strato, kiu kondukas al eksterurba marbordo. 
      Unuflanke de tiu strato situas nur uzinoj, tiutempe ne funkciantaj; kaj aliflanke – 
      nur kadukaj unu- aŭ duetaĝaj dometoj; do, fakte, piedirantoj tie ne abundis. 
      Laŭ la tuta ĝia ĉ. dekkilometra longo mi renkontis nur 3-5 homojn; sed kiom da belaĵoj troviĝis tie!
    </p>

    <p class="mb-3">
      Antaŭ ĉiu uzino situis florbedo; kelkaj estis pompaj, kun kulturitaj floroj: 
      sur unu el ili mi ĝuis admiron, alterne, de tulipoj, narcisoj, iridoj, lilioj kaj fine, superbaj ruĝaj rozoj! 
      Estis pli simplaj florbedoj kun miozotoj, primoloj, antirinoj; estis apartaj grandaj arbustoj de eglanterio en plenfloro. 
      Kaj ĉie en razenoj lumis flavaj kapituloj de leontodoj.
    </p>

    <p class="mb-3">
      Generale, mi sekvis la printempon laŭperiode: mi promenis 2-3 foje semajne, kaj ĉiam ĝuis la sekvan stadion de primavero. 
      Komencis mi, kiam floris ĉerizujoj; ili multis survoje, kaj ilia aromo tiel vigligis kaj ĝojigis koron! 
      Poste la razenoj fariĝis verdaj, kaj junaj leontodoj kapturnige odoris je mielo! 
      Poste komencis abunde verdiĝi arboj; kaj se antaŭe ili estis blankaj pro la floroj, 
      do post kelka tempo sur ili aperis teneraj helverdaj folioj, kaj kiam la suno tralumigis ilin, 
      ili fariĝis ore-verdaj, kaj milde tremetis sub vento. 
    </p>

    <p class="mb-3">
      Sekvis la tempo de robinio, kies aromo estas prikantita en poemoj kaj kantoj. 
      Kaj ĉiam estis la Suno kaj vento, la plej potencaj fortoj de Naturo. 
      Printempo jubilis! 
    </p>

    <p class="mb-3">
      Finiĝis la strato per strando; kaj la lastan kilometron mi iris jam sursable, 
      laŭ la bordo de la ĉiam apuda maro, la plej granda savanto kaj konsolanto de animo, 
      ujo de trankvilo kaj komprenemo, eterna azilo.
    </p>

    <p class="mb-3">
      Preskaŭ nerimarkinde, ĝia antaŭe senhoma bordo pleniĝis de nudaj korpoj de ripozantoj. 
      Jam indis veni al maro por naĝi. 
      Printempaj floroj forvelkis, razenoj flaviĝis pro sekeco. 
      Venis la somero. 
    </p>

    <p class="mb-3">
      Finiĝis la mirinda printempo de 2020. 
      Sed mi dankas ĝin, ĉar ĝi freŝigis kaj renovigis mian vivon. 
      Tiu printempo forŝiris la multjaran ŝelon de rutino, de ĉiutageca alkutimiĝo, kaj mi denove plenpove ekvivis.
      Mi plenspiris la printempon, mi kundividis ĝian jubilon kaj forton.
    </p>

    <p class="mb-3">
      Verda kaj ora, viva kaj majesta estis tiu printempo de 2020.
    </p>
    `
  )
}

const itemName = {
  esp: 'Printempo 2020'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item; 